import { render, staticRenderFns } from "./HandAndFingerModule.vue?vue&type=template&id=44c6aa8c&"
import script from "./HandAndFingerModule.vue?vue&type=script&lang=js&"
export * from "./HandAndFingerModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports